import React from 'react';
import { FormattedMessage } from 'react-intl';

export const LOVEBoosterIcon = () => {
  return (
    <svg
      width="222"
      height="203"
      viewBox="0 0 222 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.8)"
      className="absolute"
    >
      <path
        d="M191.178 39.3654C208.037 61.1063 185.897 106.498 141.727 140.75C97.5563 175.002 48.0821 185.144 31.223 163.404C14.3638 141.663 36.5039 96.2712 80.6743 62.019C124.845 27.7668 174.319 17.6244 191.178 39.3654Z"
        fill="#FF00A8"
      />
      <path
        d="M145.914 108.387L107 162.46C107 162.46 111.184 160.355 114.5 158.46C117.816 156.566 120 155.46 120 155.46L155.407 117.326C158.114 114.372 157.716 109.736 154.545 107.287C151.857 105.211 147.996 105.703 145.914 108.387Z"
        fill="#9EFF00"
      />
      <circle
        cx="130.254"
        cy="80.6432"
        r="43.4714"
        transform="rotate(-26.5165 130.254 80.6432)"
        fill="#7F43FF"
      />
      <path
        d="M20.6995 76.0521C20.6995 76.0521 17.8054 77.3661 18.8412 79.814C19.877 82.2619 22.7013 81.309 22.7013 81.309L108.84 56.0549C112.722 54.917 114.771 50.6759 113.251 46.9276C111.991 43.8192 108.473 42.2934 105.342 43.4975L20.6995 76.0521Z"
        fill="#9EFF00"
      />
      <path
        d="M11.3117 154.365C11.3117 154.365 8.80306 156.302 10.3578 158.456C11.9125 160.61 14.4348 159.042 14.4348 159.042L116.541 100.507C120.056 98.4917 121.085 93.8941 118.763 90.5729C116.835 87.815 113.06 87.0959 110.253 88.9517L11.3117 154.365Z"
        fill="#9EFF00"
      />
      <ellipse
        cx="157.347"
        cy="64.9371"
        rx="16.5781"
        ry="25.7881"
        transform="rotate(-26.5165 157.347 64.9371)"
        fill="black"
      />
      <path
        d="M78.5581 133.57C74.7814 129.274 73.8372 117.46 73.8372 117.46C73.8372 117.46 71.6791 129.274 68.4419 133.57C65.2047 137.866 60.7984 140.282 59 140.954C61.2481 141.401 65.2047 143.504 68.4419 148.337C71.6791 153.17 73.8372 166.46 73.8372 166.46C73.8242 166.241 74.5116 155.049 78.5581 148.337C81.4562 143.53 85.0775 141.625 88 140.954C85.9767 140.282 82.3349 137.866 78.5581 133.57Z"
        fill="white"
      />
      <path
        d="M121.681 55.4604C119.74 61.6248 121.681 77.2413 131 85.4604"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M157.007 49.5299C160.393 52.1212 167.564 59.6019 169.162 68.7945"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const VotingPowerIcon = () => {
  return (
    <svg
      width="222"
      height="203"
      viewBox="0 0 222 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.8)"
      className="absolute top-0 left-0"
    >
      <ellipse
        cx="110.504"
        cy="101.384"
        rx="101.207"
        ry="49.8145"
        transform="rotate(-37.792 110.504 101.384)"
        fill="#001AFF"
      />
      <path
        d="M126.413 96.6058C122.708 93.9048 119.756 94.4106 118.67 94.9385L122.845 98.5489C124.231 100.585 124.038 108.83 119.717 116.156C114.316 125.313 105.699 133.616 99.447 135.753C93.195 137.889 89.5219 136.359 88.3927 134.754C87.4894 133.47 85.9435 131.28 85.1035 130.553C84.7542 131.927 84.1669 136.003 86.0521 139.644C87.9373 143.285 97.1334 151.226 108 161.46C116.802 158.107 131.322 148.675 142.845 139.577C152.485 131.966 160.5 123.879 160.5 123.46C159.556 122.854 130.119 99.3068 126.413 96.6058Z"
        fill="#7F43FF"
      />
      <path
        d="M114.429 77.5571C113.618 88.9643 120 94.9607 123.032 98.8701C128.5 102.461 127 112.46 114.719 124.477C102.987 135.958 92.5001 140.262 89.6442 137.482C85.0001 132.961 87.3929 131.991 74 125.96C57.2589 118.422 24.5 88.9605 25.4865 81.7366C27.2335 68.9434 50.0766 92.1196 52.0001 87.4607C54.2768 81.9463 59.9569 72.595 63.5 66.9605C66.2359 62.6096 38.2559 43.7087 47.5 35.4605C55.2356 28.5581 93.387 75.4495 97.6882 70.0184C100.034 63.4279 106.439 50.5927 113.29 51.9757C121.853 53.7045 115.444 63.2981 114.429 77.5571Z"
        fill="white"
      />
      <path
        d="M55.2817 93.0941C58.6951 96.4112 65.0951 103.46 72.3484 103.46C79.6017 103.46 80.8817 98.899 78.7484 93.9234M78.7484 93.9234C73.6284 93.0941 66.6595 87.0128 62.1084 83.1429M78.7484 93.9234C83.8684 94.7527 87.2817 93.0941 87.2817 87.7039C87.2817 83.1922 77.0417 74.4356 66.8017 69.46"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.0637 77.2416C97.8758 79.5919 95.8057 85.6965 97.0283 91.3132C98.2509 96.9298 101.729 101.5 103.316 103.083"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M157.558 48.57C153.781 44.2741 152.837 32.4604 152.837 32.4604C152.837 32.4604 150.679 44.2741 147.442 48.57C144.205 52.8659 139.798 55.2824 138 55.9536C140.248 56.4011 144.205 58.5043 147.442 63.3372C150.679 68.17 152.837 81.4605 152.837 81.4605C152.824 81.2409 153.512 70.0495 157.558 63.3372C160.456 58.5298 164.078 56.6248 167 55.9536C164.977 55.2824 161.335 52.8659 157.558 48.57Z"
        fill="white"
      />
    </svg>
  );
};

export const PowerZone = () => {
  return (
    <svg
      width="220"
      height="223"
      viewBox="0 0 220 223"
      fill="none"
      className="PowerZone"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M117.429 14.0855L118.842 3.9636L122.1 4.41839C122.729 4.50612 123.257 4.70703 123.684 5.02112C124.113 5.32597 124.421 5.71766 124.609 6.19619C124.805 6.67601 124.861 7.22097 124.776 7.83106C124.692 8.4319 124.489 8.94073 124.167 9.35755C123.856 9.76641 123.451 10.0634 122.954 10.2485C122.459 10.4243 121.897 10.4683 121.268 10.3806L119.258 10.1L118.677 14.2597L117.429 14.0855ZM119.414 8.97687L121.425 9.25748C121.97 9.3336 122.428 9.22785 122.798 8.94024C123.178 8.64466 123.408 8.21494 123.487 7.65108C123.567 7.07797 123.463 6.6018 123.177 6.22258C122.9 5.84465 122.489 5.61762 121.943 5.5415L119.933 5.26089L119.414 8.97687Z"
        fill="#00C6A2"
      />
      <path
        d="M128.477 15.6852C127.877 15.5468 127.385 15.3136 127 14.9856C126.616 14.6576 126.351 14.2515 126.204 13.7674C126.068 13.2764 126.068 12.7353 126.205 12.1441L126.664 10.1524C126.802 9.55211 127.039 9.06553 127.374 8.6926C127.718 8.32178 128.135 8.07301 128.624 7.94631C129.113 7.8196 129.657 7.82546 130.257 7.96387C130.858 8.10228 131.35 8.3355 131.734 8.66353C132.118 8.99156 132.379 9.39656 132.517 9.87854C132.664 10.3626 132.669 10.9002 132.533 11.4914L132.071 13.4968C131.934 14.0879 131.693 14.5734 131.347 14.9534C131.012 15.3263 130.6 15.5761 130.111 15.7028C129.622 15.8295 129.077 15.8237 128.477 15.6852ZM128.729 14.5939C129.265 14.7176 129.718 14.664 130.088 14.4331C130.457 14.2022 130.709 13.7957 130.843 13.2136L131.302 11.2219C131.436 10.6398 131.388 10.1641 131.157 9.79482C130.926 9.42549 130.542 9.17896 130.006 9.05523C129.478 8.93359 129.025 8.98719 128.647 9.21601C128.278 9.44693 128.026 9.85342 127.892 10.4355L127.432 12.4272C127.298 13.0093 127.346 13.485 127.577 13.8543C127.817 14.2257 128.201 14.4723 128.729 14.5939Z"
        fill="#00C6A2"
      />
      <path
        d="M134.71 16.7442L135.944 9.04451L137.008 9.39426L136.035 14.8217C135.997 15.0255 135.954 15.247 135.905 15.4863C135.867 15.7196 135.833 15.9146 135.801 16.0711C135.868 15.9262 135.956 15.7488 136.064 15.5388C136.185 15.3228 136.29 15.1217 136.381 14.9353L138.897 10.0151L140.041 10.391L139.147 15.8447C139.11 16.0485 139.071 16.2715 139.03 16.5137C139.002 16.7499 138.972 16.9463 138.94 17.1029C139.007 16.958 139.095 16.7805 139.203 16.5705C139.323 16.3546 139.429 16.1534 139.519 15.9671L141.983 11.0293L142.993 11.3616L139.365 18.2743L138.049 17.8415L138.925 12.5296C138.971 12.2697 139.013 12.0083 139.05 11.7455C139.088 11.4826 139.121 11.2774 139.15 11.1297C139.085 11.2657 138.994 11.452 138.877 11.6886C138.76 11.9252 138.639 12.1604 138.513 12.3941L136.027 17.177L134.71 16.7442Z"
        fill="#00C6A2"
      />
      <path
        d="M145.194 20.3051C144.637 20.0646 144.197 19.7423 143.873 19.3382C143.558 18.9378 143.372 18.4863 143.314 17.9837C143.269 17.4762 143.363 16.9525 143.596 16.4127L144.429 14.4848C144.665 13.9364 144.982 13.5089 145.379 13.2024C145.784 12.8995 146.24 12.7255 146.748 12.6803C147.264 12.6389 147.8 12.7384 148.357 12.9788C148.914 13.2193 149.35 13.5398 149.666 13.9402C149.989 14.3442 150.175 14.7957 150.224 15.2947C150.282 15.7973 150.192 16.3228 149.955 16.8712L149.417 18.1179L145.021 16.2199L144.727 16.9011C144.487 17.4581 144.443 17.9475 144.596 18.3695C144.753 18.783 145.093 19.1025 145.616 19.3282C146.061 19.5206 146.455 19.5989 146.795 19.5631C147.14 19.5187 147.411 19.3509 147.607 19.0597L148.764 19.5592C148.432 20.1172 147.937 20.4626 147.28 20.5957C146.635 20.7238 145.939 20.6269 145.194 20.3051ZM148.619 16.8584L148.824 16.3828C149.065 15.8258 149.108 15.3364 148.955 14.9144C148.81 14.4961 148.472 14.1722 147.941 13.9428C147.419 13.7171 146.951 13.6932 146.539 13.871C146.127 14.0488 145.8 14.4162 145.56 14.9731L145.399 15.3459L148.753 16.7944L148.619 16.8584Z"
        fill="#00C6A2"
      />
      <path
        d="M150.725 22.2477L154.395 15.4782L155.478 16.0653L154.777 17.3576L155.036 17.4977L154.245 18.1043C154.641 17.374 155.095 16.9087 155.607 16.7085C156.131 16.5045 156.705 16.5715 157.329 16.9095C158.043 17.2965 158.487 17.829 158.661 18.5072C158.847 19.1815 158.734 19.9003 158.32 20.6634L158.1 21.0695L156.992 20.4691L157.159 20.1614C157.448 19.6281 157.537 19.1507 157.426 18.7294C157.327 18.3043 157.04 17.9628 156.564 17.7049C156.096 17.4513 155.649 17.3948 155.222 17.5352C154.804 17.6801 154.453 18.0151 154.168 18.5402L151.833 22.8481L150.725 22.2477Z"
        fill="#00C6A2"
      />
      <path
        d="M161.36 27.7999L162.097 26.7783L170.404 23.14L166.727 20.4851L167.398 19.5543L172.109 22.9548L171.372 23.9765L163.065 27.6147L166.913 30.3925L166.241 31.3234L161.36 27.7999Z"
        fill="#00C6A2"
      />
      <path
        d="M170.517 34.4963C170.051 34.0935 169.725 33.6574 169.539 33.1879C169.352 32.7185 169.307 32.2354 169.403 31.7387C169.513 31.2411 169.766 30.7628 170.162 30.3038L171.499 28.7573C171.902 28.2912 172.338 27.9716 172.809 27.7984C173.286 27.6312 173.771 27.6059 174.262 27.7223C174.754 27.8387 175.233 28.0983 175.699 28.5011C176.165 28.9039 176.491 29.34 176.677 29.8095C176.864 30.279 176.905 30.759 176.802 31.2496C176.706 31.7462 176.459 32.2241 176.063 32.6831L174.717 34.2401C174.32 34.6991 173.88 35.0157 173.397 35.1899C172.926 35.3631 172.445 35.3915 171.954 35.2751C171.462 35.1587 170.983 34.8991 170.517 34.4963ZM171.25 33.649C171.666 34.009 172.092 34.1732 172.526 34.1416C172.961 34.11 173.373 33.8682 173.764 33.4162L175.1 31.8698C175.491 31.4178 175.67 30.9746 175.639 30.5402C175.607 30.1058 175.383 29.7085 174.966 29.3485C174.557 28.9945 174.131 28.8303 173.69 28.8558C173.255 28.8874 172.843 29.1292 172.452 29.5812L171.116 31.1277C170.725 31.5796 170.546 32.0228 170.577 32.4572C170.616 32.8977 170.84 33.295 171.25 33.649Z"
        fill="#00C6A2"
      />
      <path
        d="M174.904 37.7408L180.427 32.3758L181.305 33.2796L180.251 34.3039L180.436 34.4947L180.04 34.5087C180.475 34.086 180.937 33.8914 181.424 33.9249C181.919 33.9519 182.391 34.1964 182.839 34.6583C183.379 35.214 183.638 35.8217 183.615 36.4814C183.592 37.1411 183.286 37.7571 182.697 38.3293L178.981 41.9385L178.103 41.0347L181.719 37.5231C182.114 37.1394 182.311 36.7396 182.31 36.3238C182.323 35.9082 182.154 35.5196 181.803 35.1581C181.438 34.7832 181.035 34.5958 180.593 34.596C180.157 34.6028 179.725 34.8144 179.297 35.2305L175.782 38.6447L174.904 37.7408Z"
        fill="#00C6A2"
      />
      <path
        d="M183.069 46.3226C182.687 45.8508 182.447 45.3609 182.348 44.8527C182.255 44.3517 182.3 43.8654 182.483 43.3936C182.679 42.9232 183.005 42.5032 183.462 42.1335L185.095 40.8131C185.56 40.4375 186.039 40.2062 186.533 40.119C187.032 40.0392 187.517 40.0972 187.987 40.2929C188.464 40.496 188.893 40.8334 189.274 41.3051C189.655 41.7769 189.893 42.2632 189.986 42.7642C190.084 43.2724 190.04 43.7587 189.851 44.2232C189.668 44.695 189.345 45.1187 188.88 45.4943L187.824 46.3481L184.814 42.6249L184.237 43.0915C183.765 43.4729 183.499 43.8861 183.439 44.331C183.386 44.77 183.538 45.2109 183.896 45.6536C184.201 46.031 184.513 46.283 184.831 46.4096C185.157 46.5304 185.475 46.5076 185.784 46.3412L186.577 47.321C186.023 47.6606 185.424 47.7366 184.781 47.549C184.15 47.3628 183.579 46.954 183.069 46.3226ZM187.703 44.8619L188.106 44.5362C188.577 44.1548 188.844 43.7416 188.904 43.2967C188.97 42.8591 188.821 42.4153 188.457 41.9653C188.1 41.5226 187.697 41.2842 187.249 41.2501C186.801 41.216 186.342 41.3896 185.87 41.7711L185.554 42.0264L187.852 44.8677L187.703 44.8619Z"
        fill="#00C6A2"
      />
      <path
        d="M99.5859 207.428L98.1731 217.55L94.9147 217.095C94.2861 217.008 93.7582 216.807 93.3308 216.493C92.9022 216.188 92.594 215.796 92.4064 215.317C92.2095 214.838 92.1536 214.293 92.2388 213.683C92.3226 213.082 92.5256 212.573 92.8476 212.156C93.1591 211.747 93.5634 211.45 94.0604 211.265C94.5562 211.089 95.1183 211.045 95.7469 211.133L97.7574 211.414L98.338 207.254L99.5859 207.428ZM97.6006 212.537L95.5901 212.256C95.0447 212.18 94.5871 212.286 94.2171 212.573C93.8366 212.869 93.607 213.299 93.5283 213.863C93.4483 214.436 93.5514 214.912 93.8378 215.291C94.1149 215.669 94.5261 215.896 95.0715 215.972L97.082 216.253L97.6006 212.537Z"
        fill="#00C6A2"
      />
      <path
        d="M88.5379 205.828C89.1382 205.967 89.6303 206.2 90.0145 206.528C90.3986 206.856 90.6641 207.262 90.8111 207.746C90.9469 208.237 90.9467 208.778 90.8103 209.37L90.3511 211.361C90.2127 211.962 89.9759 212.448 89.6409 212.821C89.2968 213.192 88.8802 213.441 88.3913 213.567C87.9023 213.694 87.3577 213.688 86.7574 213.55C86.1572 213.411 85.665 213.178 85.2809 212.85C84.8968 212.522 84.6358 212.117 84.4979 211.635C84.3509 211.151 84.3455 210.613 84.4819 210.022L84.9443 208.017C85.0806 207.426 85.3219 206.94 85.6681 206.56C86.0031 206.187 86.4151 205.938 86.9041 205.811C87.3931 205.684 87.9377 205.69 88.5379 205.828ZM88.2863 206.92C87.7497 206.796 87.2967 206.85 86.9274 207.081C86.5581 207.311 86.3063 207.718 86.1721 208.3L85.7128 210.292C85.5786 210.874 85.6269 211.35 85.8578 211.719C86.0888 212.088 86.4725 212.335 87.0091 212.458C87.5366 212.58 87.9895 212.526 88.368 212.298C88.7373 212.067 88.9891 211.66 89.1233 211.078L89.5826 209.086C89.7168 208.504 89.6684 208.029 89.4375 207.659C89.1975 207.288 88.8137 207.041 88.2863 206.92Z"
        fill="#00C6A2"
      />
      <path
        d="M82.3046 204.77L81.0704 212.469L80.0065 212.119L80.98 206.692C81.0175 206.488 81.0609 206.267 81.11 206.027C81.1474 205.794 81.182 205.599 81.2139 205.443C81.1466 205.587 81.0588 205.765 80.9504 205.975C80.8303 206.191 80.7249 206.392 80.6342 206.578L78.1179 211.499L76.9741 211.123L77.8678 205.669C77.9053 205.465 77.9443 205.242 77.9846 205C78.0131 204.764 78.0433 204.567 78.0751 204.411C78.0078 204.556 77.92 204.733 77.8117 204.943C77.6916 205.159 77.5861 205.36 77.4954 205.547L75.0323 210.484L74.0215 210.152L77.6496 203.239L78.9663 203.672L78.0897 208.984C78.0436 209.244 78.0018 209.505 77.9646 209.768C77.9273 210.031 77.8942 210.236 77.8653 210.384C77.9297 210.248 78.0204 210.062 78.1375 209.825C78.2545 209.588 78.3761 209.353 78.502 209.12L80.9879 204.337L82.3046 204.77Z"
        fill="#00C6A2"
      />
      <path
        d="M71.8209 201.209C72.3778 201.449 72.8182 201.771 73.1418 202.175C73.4569 202.576 73.6432 203.027 73.7007 203.53C73.7458 204.037 73.6519 204.561 73.4188 205.101L72.5863 207.029C72.3495 207.577 72.0328 208.005 71.6361 208.311C71.2309 208.614 70.7745 208.788 70.267 208.833C69.7509 208.875 69.2144 208.775 68.6575 208.535C68.1005 208.294 67.6645 207.974 67.3494 207.574C67.0257 207.169 66.8394 206.718 66.7905 206.219C66.7331 205.716 66.8227 205.191 67.0595 204.642L67.5979 203.396L71.9936 205.294L72.2877 204.613C72.5282 204.056 72.5718 203.566 72.4186 203.144C72.2616 202.731 71.9218 202.411 71.3991 202.185C70.9535 201.993 70.5603 201.915 70.2195 201.951C69.875 201.995 69.6044 202.163 69.4075 202.454L68.2507 201.954C68.5831 201.397 69.078 201.051 69.7352 200.918C70.3802 200.79 71.0754 200.887 71.8209 201.209ZM68.3959 204.655L68.1906 205.131C67.9501 205.688 67.9065 206.177 68.0598 206.599C68.2045 207.018 68.5424 207.341 69.0737 207.571C69.5964 207.797 70.0639 207.82 70.4761 207.643C70.8884 207.465 71.2148 207.097 71.4553 206.541L71.6162 206.168L68.2616 204.719L68.3959 204.655Z"
        fill="#00C6A2"
      />
      <path
        d="M66.2896 199.266L62.6203 206.036L61.5372 205.448L62.2377 204.156L61.9792 204.016L62.7698 203.409C62.374 204.14 61.9201 204.605 61.4081 204.805C60.8835 205.009 60.3094 204.942 59.6858 204.604C58.9719 204.217 58.528 203.685 58.3542 203.007C58.1677 202.332 58.2812 201.613 58.6949 200.85L58.915 200.444L60.0228 201.045L59.856 201.352C59.5669 201.886 59.478 202.363 59.5894 202.784C59.6881 203.209 59.9754 203.551 60.4513 203.809C60.919 204.062 61.3661 204.119 61.7925 203.978C62.2108 203.834 62.5622 203.499 62.8469 202.973L65.1819 198.666L66.2896 199.266Z"
        fill="#00C6A2"
      />
      <path
        d="M55.6549 193.714L54.9174 194.735L46.6105 198.374L50.2884 201.029L49.6164 201.959L44.9056 198.559L45.643 197.537L53.95 193.899L50.1018 191.121L50.7737 190.19L55.6549 193.714Z"
        fill="#00C6A2"
      />
      <path
        d="M46.4976 187.017C46.9637 187.42 47.2899 187.856 47.4763 188.325C47.6627 188.795 47.7078 189.278 47.6116 189.774C47.5022 190.272 47.2492 190.75 46.8525 191.209L45.516 192.756C45.1132 193.222 44.6766 193.542 44.2062 193.715C43.7287 193.882 43.2442 193.907 42.7526 193.791C42.2611 193.674 41.7823 193.415 41.3162 193.012C40.8502 192.609 40.524 192.173 40.3376 191.704C40.1512 191.234 40.1096 190.754 40.2129 190.264C40.309 189.767 40.5555 189.289 40.9521 188.83L42.2978 187.273C42.6945 186.814 43.1347 186.497 43.6183 186.323C44.0887 186.15 44.5697 186.122 45.0612 186.238C45.5528 186.354 46.0315 186.614 46.4976 187.017ZM45.7653 187.864C45.3486 187.504 44.9231 187.34 44.4887 187.372C44.0542 187.403 43.6417 187.645 43.2512 188.097L41.9146 189.643C41.524 190.095 41.3446 190.539 41.3762 190.973C41.4078 191.407 41.632 191.805 42.0486 192.165C42.4582 192.519 42.8837 192.683 43.3252 192.657C43.7596 192.626 44.1721 192.384 44.5627 191.932L45.8992 190.386C46.2898 189.934 46.4693 189.49 46.4377 189.056C46.399 188.615 46.1748 188.218 45.7653 187.864Z"
        fill="#00C6A2"
      />
      <path
        d="M42.111 183.773L36.5877 189.138L35.7098 188.234L36.7642 187.21L36.5789 187.019L36.9751 187.005C36.5399 187.428 36.0784 187.622 35.5904 187.589C35.0958 187.562 34.6241 187.317 34.1754 186.855C33.6357 186.3 33.3772 185.692 33.4 185.032C33.4228 184.373 33.7287 183.757 34.3179 183.184L38.0335 179.575L38.9115 180.479L35.2962 183.991C34.9012 184.374 34.704 184.774 34.7046 185.19C34.6919 185.606 34.8612 185.994 35.2123 186.356C35.5765 186.731 35.9797 186.918 36.4219 186.918C36.8577 186.911 37.2898 186.699 37.7182 186.283L41.2331 182.869L42.111 183.773Z"
        fill="#00C6A2"
      />
      <path
        d="M33.9462 175.191C34.3276 175.663 34.5678 176.153 34.6666 176.661C34.7596 177.162 34.7148 177.648 34.5321 178.12C34.3363 178.59 34.0098 179.011 33.5526 179.38L31.9196 180.701C31.4551 181.076 30.976 181.308 30.4824 181.395C29.9828 181.474 29.4978 181.417 29.0275 181.221C28.5512 181.018 28.1224 180.68 27.7409 180.209C27.3595 179.737 27.1223 179.25 27.0293 178.75C26.9304 178.241 26.9753 177.755 27.1638 177.29C27.3465 176.819 27.67 176.395 28.1345 176.019L29.1905 175.166L32.201 178.889L32.778 178.422C33.2497 178.041 33.5158 177.628 33.5761 177.183C33.6292 176.744 33.4768 176.303 33.1188 175.86C32.8137 175.483 32.5019 175.231 32.1835 175.104C31.8578 174.983 31.5401 175.006 31.2305 175.172L30.4383 174.193C30.9919 173.853 31.5906 173.777 32.2344 173.965C32.865 174.151 33.4357 174.56 33.9462 175.191ZM29.312 176.652L28.9092 176.977C28.4374 177.359 28.1714 177.772 28.111 178.217C28.0448 178.655 28.1936 179.098 28.5574 179.548C28.9154 179.991 29.3182 180.229 29.7659 180.264C30.2135 180.298 30.6733 180.124 31.145 179.743L31.4607 179.487L29.1632 176.646L29.312 176.652Z"
        fill="#00C6A2"
      />
      <path
        d="M103.307 9.08831C46.2522 12.5765 2.82777 61.6565 6.31599 118.711C7.45962 137.417 13.5039 154.658 23.123 169.26M198.243 58.8877C206.628 72.7487 211.873 88.7881 212.93 106.079C216.418 163.134 172.994 212.214 115.939 215.703C112.808 215.894 109.7 215.944 106.623 215.858"
        stroke="#00C6A2"
      />
    </svg>
  );
};

export const LOVE_ICON = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#0F1D27" stroke="#00D6AF" />
      <mask
        id="path-2-outside-1_157_1039"
        maskUnits="userSpaceOnUse"
        x="2.84619"
        y="4.38477"
        width="15"
        height="13"
        fill="black"
      >
        <rect fill="white" x="2.84619" y="4.38477" width="15" height="13" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.63259 5.38477H6.58127V6.92325L5.21378 6.92325V8.46174H3.84619V10.0002H5.21378V11.5387H6.58127V13.0772H7.94886V14.6157H9.31635V16.1542H10.6839V14.6157H12.0515V13.0772H13.419V11.5387H14.7866V10.0002H16.1541V8.46174H14.7866V6.92325L13.419 6.92325V5.38477H11.3677V6.92325H8.63259V5.38477Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63259 5.38477H6.58127V6.92325L5.21378 6.92325V8.46174H3.84619V10.0002H5.21378V11.5387H6.58127V13.0772H7.94886V14.6157H9.31635V16.1542H10.6839V14.6157H12.0515V13.0772H13.419V11.5387H14.7866V10.0002H16.1541V8.46174H14.7866V6.92325L13.419 6.92325V5.38477H11.3677V6.92325H8.63259V5.38477Z"
        fill="url(#paint0_linear_157_1039)"
      />
      <path
        d="M6.58127 5.38477V4.38477H5.58127V5.38477H6.58127ZM8.63259 5.38477H9.63259V4.38477H8.63259V5.38477ZM6.58127 6.92325L6.58127 7.92325L7.58127 7.92325V6.92325H6.58127ZM5.21378 6.92325L5.21378 5.92325L4.21378 5.92325V6.92325H5.21378ZM5.21378 8.46174V9.46174H6.21378V8.46174H5.21378ZM3.84619 8.46174V7.46174H2.84619V8.46174H3.84619ZM3.84619 10.0002H2.84619V11.0002H3.84619V10.0002ZM5.21378 10.0002H6.21378V9.00023H5.21378V10.0002ZM5.21378 11.5387H4.21378V12.5387H5.21378V11.5387ZM6.58127 11.5387H7.58127V10.5387H6.58127V11.5387ZM6.58127 13.0772H5.58127V14.0772H6.58127V13.0772ZM7.94886 13.0772H8.94886V12.0772H7.94886V13.0772ZM7.94886 14.6157H6.94886V15.6157H7.94886V14.6157ZM9.31635 14.6157H10.3163V13.6157H9.31635V14.6157ZM9.31635 16.1542H8.31635V17.1542H9.31635V16.1542ZM10.6839 16.1542V17.1542H11.6839V16.1542H10.6839ZM10.6839 14.6157V13.6157H9.68389V14.6157H10.6839ZM12.0515 14.6157V15.6157H13.0515V14.6157H12.0515ZM12.0515 13.0772V12.0772H11.0515V13.0772H12.0515ZM13.419 13.0772V14.0772H14.419V13.0772H13.419ZM13.419 11.5387V10.5387H12.419V11.5387H13.419ZM14.7866 11.5387V12.5387H15.7866V11.5387H14.7866ZM14.7866 10.0002V9.00023H13.7866V10.0002H14.7866ZM16.1541 10.0002V11.0002H17.1541V10.0002H16.1541ZM16.1541 8.46174H17.1541V7.46174H16.1541V8.46174ZM14.7866 8.46174H13.7866V9.46174H14.7866V8.46174ZM14.7866 6.92325H15.7866V5.92325L14.7866 5.92325V6.92325ZM13.419 6.92325H12.419V7.92325L13.419 7.92325V6.92325ZM13.419 5.38477H14.419V4.38477H13.419V5.38477ZM11.3677 5.38477V4.38477H10.3677V5.38477H11.3677ZM11.3677 6.92325V7.92325H12.3677V6.92325H11.3677ZM8.63259 6.92325H7.63259V7.92325H8.63259V6.92325ZM6.58127 6.38477H8.63259V4.38477H6.58127V6.38477ZM7.58127 6.92325V5.38477H5.58127V6.92325H7.58127ZM5.21378 7.92325H6.58127L6.58127 5.92325L5.21378 5.92325L5.21378 7.92325ZM6.21378 8.46174V6.92325H4.21378V8.46174H6.21378ZM3.84619 9.46174H5.21378V7.46174H3.84619V9.46174ZM4.84619 10.0002V8.46174H2.84619V10.0002H4.84619ZM5.21378 9.00023H3.84619V11.0002H5.21378V9.00023ZM6.21378 11.5387V10.0002H4.21378V11.5387H6.21378ZM6.58127 10.5387H5.21378V12.5387H6.58127V10.5387ZM7.58127 13.0772V11.5387H5.58127V13.0772H7.58127ZM7.94886 12.0772H6.58127V14.0772H7.94886V12.0772ZM8.94886 14.6157V13.0772H6.94886V14.6157H8.94886ZM9.31635 13.6157H7.94886V15.6157H9.31635V13.6157ZM10.3163 16.1542V14.6157H8.31635V16.1542H10.3163ZM10.6839 15.1542H9.31635V17.1542H10.6839V15.1542ZM9.68389 14.6157V16.1542H11.6839V14.6157H9.68389ZM12.0515 13.6157H10.6839V15.6157H12.0515V13.6157ZM11.0515 13.0772V14.6157H13.0515V13.0772H11.0515ZM13.419 12.0772H12.0515V14.0772H13.419V12.0772ZM12.419 11.5387V13.0772H14.419V11.5387H12.419ZM14.7866 10.5387H13.419V12.5387H14.7866V10.5387ZM13.7866 10.0002V11.5387H15.7866V10.0002H13.7866ZM16.1541 9.00023H14.7866V11.0002H16.1541V9.00023ZM15.1541 8.46174V10.0002H17.1541V8.46174H15.1541ZM14.7866 9.46174H16.1541V7.46174H14.7866V9.46174ZM13.7866 6.92325V8.46174H15.7866V6.92325H13.7866ZM13.419 7.92325H14.7866V5.92325L13.419 5.92325V7.92325ZM12.419 5.38477V6.92325H14.419V5.38477H12.419ZM11.3677 6.38477H13.419V4.38477H11.3677V6.38477ZM12.3677 6.92325V5.38477H10.3677V6.92325H12.3677ZM8.63259 7.92325H11.3677V5.92325H8.63259V7.92325ZM7.63259 5.38477V6.92325H9.63259V5.38477H7.63259Z"
        fill="#00FFD1"
        mask="url(#path-2-outside-1_157_1039)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_157_1039"
          x1="10.0001"
          y1="5.38477"
          x2="10.0001"
          y2="16.1542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A076FF" />
          <stop offset="1" stopColor="#A076FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LeftArrowVE = ({
  stroke,
  strokeWidth,
  size,
}: {
  stroke?: string;
  strokeWidth?: number;
  size?: string;
}) => {
  return (
    <svg
      width="27"
      height="18"
      viewBox="0 0 27 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 9L1.37143 9M8.8 17L0.999998 9L8.8 1"
        stroke={stroke || 'black'}
        strokeWidth={strokeWidth || 1}
      />
    </svg>
  );
};

export const RightArrowVE = ({ stroke }: { stroke?: string }) => {
  return (
    <svg
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19629e-07 5.2L15.7714 5.2M11.2 10L16 5.2L11.2 0.399998"
        stroke={stroke || '#00FFD1'}
      />
    </svg>
  );
};

export const VE_ICON = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#0F1D27" stroke="#00D6AF" />
      <rect
        x="4.375"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="4.375"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98077"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="10.8799"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="12.6309"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="12.6309"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="4.375"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="5.40524"
        y="10.7764"
        width="3.34822"
        height="1.80289"
        fill="#00FFD1"
      />
      <rect
        x="6.17786"
        y="12.5791"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98083"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98083"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
    </svg>
  );
};

export const NO_RESULT_CHART = ({ expand }: { expand?: string }) => {
  return (
    <svg
      width="125"
      height="125"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`scale(${expand || 1},${expand || 1})`}
    >
      <circle
        cx="62.5"
        cy="62.5"
        r="54.5"
        stroke="url(#paint0_linear_508_37)"
        strokeWidth="16"
      />
      <defs>
        <linearGradient
          id="paint0_linear_508_37"
          x1="62.5"
          y1="0"
          x2="62.5"
          y2="125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#849DA8" />
          <stop offset="1" stopColor="#849DA8" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const NoResultChart = ({ expand }: { expand?: string }) => {
  return (
    <div className={`relative`}>
      <NO_RESULT_CHART expand={expand} />
      <div className="absolute whitespace-nowrap right-1/2 top-1/2 text-sm text-primaryText transform translate-x-1/2 -translate-y-1/2">
        <FormattedMessage
          id="no_result_pending_proposal"
          defaultMessage={'No result'}
        />
      </div>
    </div>
  );
};

export const VotedIcon = () => {
  return (
    <svg
      width="96"
      height="95"
      viewBox="0 0 96 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.6 13.146C55.4723 11.4836 59.1485 12.4687 60.8048 15.3445L63.899 20.7167C64.7858 22.2566 66.3097 23.3242 68.0599 23.6317L74.1633 24.7042C77.4297 25.2781 79.6109 28.3932 79.0331 31.659L77.9498 37.7814C77.6406 39.529 78.1209 41.3238 79.2617 42.6833L83.2557 47.4435C85.3855 49.9819 85.0544 53.7662 82.5161 55.8962L77.7507 59.8951C76.3919 61.0355 75.6073 62.7186 75.6076 64.4926L75.609 70.715C75.6097 74.0297 72.9224 76.717 69.6077 76.7162L63.4034 76.7149C61.6274 76.7145 59.9426 77.5009 58.8023 78.8624L54.8159 83.6221C52.6855 86.1658 48.8949 86.4975 46.3551 84.3623L41.6131 80.3759C40.2526 79.2321 38.455 78.7504 36.7048 79.0607L30.6049 80.1421C27.3378 80.7213 24.2209 78.5388 23.6477 75.2706L22.5753 69.1555C22.2685 67.4062 21.2026 65.8827 19.6644 64.9951L14.2906 61.8941C11.4197 60.2374 10.4361 56.5665 12.094 53.6962L15.2064 48.3081C16.0937 46.772 16.2558 44.922 15.6491 43.2551L13.5216 37.4092C12.3884 34.2954 13.9938 30.8526 17.1075 29.7192L22.9465 27.5937C24.6142 26.9867 25.9275 25.6725 26.5336 24.0044L28.6566 18.1607C29.7891 15.0435 33.2356 13.4364 36.3514 14.5725L42.1733 16.6954C43.8428 17.3042 45.6963 17.1416 47.2343 16.2515L52.6 13.146Z"
        fill="url(#paint0_linear_586_374)"
      />
      <path
        d="M51.5238 18.5292C54.1568 17.0054 57.5266 17.9083 59.0449 20.5445L61.1441 24.1892C62.1048 25.8574 63.7557 27.0139 65.6517 27.3471L69.7927 28.0747C72.7869 28.6008 74.7864 31.4564 74.2567 34.45L73.521 38.6082C73.186 40.5014 73.7063 42.4458 74.9421 43.9186L77.655 47.1519C79.6073 49.4787 79.3038 52.9477 76.9771 54.9002L73.7391 57.6173C72.267 58.8527 71.417 60.6761 71.4174 62.5979L71.4183 66.8257C71.4189 69.8642 68.9556 72.3275 65.9171 72.3269L61.7054 72.326C59.7815 72.3256 57.9562 73.1775 56.7209 74.6525L54.0151 77.8832C52.0622 80.215 48.5875 80.519 46.2593 78.5618L43.0428 75.8577C41.5689 74.6186 39.6214 74.0968 37.7254 74.4329L33.5878 75.1664C30.593 75.6974 27.7358 73.6968 27.2104 70.7009L26.4824 66.5501C26.1501 64.6551 24.9953 63.0047 23.329 62.043L19.6811 59.938C17.0494 58.4193 16.1477 55.0543 17.6675 52.4233L19.7822 48.7623C20.7435 47.0982 20.9191 45.094 20.2618 43.2882L18.8163 39.316C17.7775 36.4618 19.2491 33.3058 22.1033 32.2669L26.0693 30.8232C27.876 30.1656 29.2988 28.7419 29.9553 26.9348L31.3973 22.9658C32.4353 20.1084 35.5947 18.6352 38.4509 19.6767L42.4008 21.117C44.2095 21.7765 46.2174 21.6004 47.8835 20.636L51.5238 18.5292Z"
        stroke="white"
        stroke-opacity="0.3"
      />
      <path
        d="M32.9659 47.8398L31.45 37.2154L32.64 37.5343L33.8223 46.5909L39.388 39.3424L40.5374 39.6504L33.9125 48.0934L32.9659 47.8398ZM44.7847 49.963C43.8906 50.4868 42.9252 50.6098 41.8885 50.332C40.8517 50.0542 40.0805 49.4707 39.5747 48.5815C39.0804 47.6857 38.9673 46.7375 39.2354 45.7368L39.2427 45.7097C39.5108 44.709 40.0874 43.9456 40.9724 43.4194C41.8688 42.8866 42.8354 42.7591 43.8722 43.0369C44.909 43.3147 45.679 43.9027 46.1824 44.8009C46.6881 45.6901 46.8069 46.635 46.5388 47.6357L46.5315 47.6628C46.2634 48.6635 45.6811 49.4302 44.7847 49.963ZM42.1655 49.4062C42.9138 49.6067 43.5969 49.5095 44.2148 49.1146C44.8418 48.7222 45.2555 48.1518 45.456 47.4036L45.4632 47.3765C45.6661 46.6192 45.5864 45.907 45.2241 45.2398C44.8708 44.5751 44.329 44.1448 43.5988 43.9492C42.8595 43.7511 42.1752 43.8528 41.5459 44.2542C40.9279 44.6491 40.5187 45.2207 40.3182 45.9689L40.311 45.996C40.1081 46.7533 40.1833 47.4643 40.5366 48.1291C40.8923 48.7848 41.4353 49.2105 42.1655 49.4062ZM49.7898 52.4057C49.1858 52.2438 48.7457 51.9568 48.4697 51.5447C48.205 51.1259 48.1633 50.5785 48.3445 49.9023L49.475 45.6831L48.5013 45.4222L48.7477 44.5027L49.7214 44.7636L50.2866 42.654L51.3279 42.933L50.7627 45.0426L52.9804 45.6368L52.734 46.5564L50.5163 45.9621L49.422 50.0461C49.2142 50.8214 49.5025 51.3141 50.2868 51.5243C50.6294 51.6161 50.9892 51.6255 51.3663 51.5526L51.1271 52.4452C50.6954 52.542 50.2496 52.5289 49.7898 52.4057ZM54.1967 50.166C54.078 50.8975 54.1918 51.5367 54.538 52.0836C54.8957 52.624 55.3946 52.9799 56.0347 53.1514C56.8731 53.376 57.696 53.2439 58.5034 52.7548L58.9967 53.5102C57.9781 54.1746 56.9008 54.3545 55.7648 54.0502C54.7822 53.7869 54.0433 53.2266 53.5484 52.3692C53.0648 51.5053 52.9668 50.5369 53.2543 49.4641C53.5272 48.4454 54.078 47.6702 54.9065 47.1385C55.7374 46.5978 56.6307 46.4555 57.5863 46.7115C58.587 46.9797 59.2861 47.5438 59.6837 48.4041C60.0813 49.2643 60.1375 50.2263 59.8525 51.2901C59.8163 51.4253 59.7791 51.5458 59.7411 51.6516L54.1967 50.166ZM54.4214 49.3275L58.9245 50.5342C59.0426 49.8411 58.967 49.2218 58.6977 48.6761C58.4398 48.1239 57.9818 47.7596 57.3237 47.5833C56.7287 47.4239 56.1602 47.5082 55.6181 47.8365C55.076 48.1647 54.6771 48.6617 54.4214 49.3275ZM63.6496 56.1484C62.7571 55.9092 62.0654 55.3712 61.5746 54.5344C61.0839 53.6975 60.9858 52.7291 61.2805 51.6292L61.2878 51.6022C61.5801 50.5113 62.1492 49.7217 62.995 49.2334C63.8409 48.745 64.7101 48.6204 65.6027 48.8595C66.7025 49.1542 67.4622 49.8892 67.8816 51.0645L69.0121 46.8453L70.0534 47.1243L67.4083 56.9961L66.367 56.7171L66.7438 55.3107C65.7629 56.159 64.7314 56.4383 63.6496 56.1484ZM64.0889 55.266C64.7651 55.4472 65.4232 55.353 66.0634 54.9834C66.7059 54.6048 67.1323 54.0234 67.3424 53.239L67.3497 53.212C67.5574 52.4367 67.4765 51.7289 67.1069 51.0888C66.7398 50.4397 66.2181 50.0245 65.542 49.8433C64.8388 49.6549 64.1875 49.7413 63.5883 50.1025C62.9891 50.4637 62.5795 51.0545 62.3597 51.8749L62.3525 51.902C62.1375 52.7043 62.2012 53.422 62.5438 54.0548C62.8887 54.6787 63.4038 55.0824 64.0889 55.266Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_586_374"
          x1="57.804"
          y1="10.1341"
          x2="37.8212"
          y2="84.7109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C6A2" />
          <stop offset="1" stopColor="#00866E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const GiftIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.68022 7.23758C8.65395 7.23758 8.62767 7.23598 8.60141 7.2324C7.72578 7.11976 6.46886 6.77747 5.4547 5.7876C4.76135 5.11018 4.51858 4.12031 4.82107 3.20409C5.14187 2.23015 6.0167 1.55473 7.15981 1.39712C7.77433 1.31394 8.404 1.51812 8.89595 1.95992C9.35924 2.37743 9.71505 2.7858 9.98093 3.21605C10.2229 2.85943 10.5326 2.50281 10.9195 2.13106C11.5634 1.51254 12.4725 1.26657 13.2845 1.48748C14.2636 1.75336 14.9888 2.45266 15.2244 3.35815C15.4496 4.22622 15.1901 5.15717 14.5454 5.78722C13.7557 6.55738 12.7344 7.03897 11.5093 7.21927C11.1742 7.26982 10.8645 7.03737 10.8152 6.70304C10.7658 6.36911 10.9975 6.05866 11.331 6.00931C12.2966 5.86763 13.0902 5.49866 13.6912 4.91278C14.0272 4.58362 14.1585 4.11753 14.0407 3.6658C13.9157 3.18301 13.5233 2.81924 12.9645 2.66718C12.5649 2.56051 12.0976 2.69504 11.7664 3.01266C11.0373 3.71357 10.6735 4.2887 10.5517 4.93706C10.4968 5.22602 10.2444 5.43498 9.95071 5.43498C9.65697 5.43498 9.40464 5.22602 9.34972 4.93706C9.22395 4.26959 8.95887 3.66222 8.07766 2.86898C7.85795 2.67118 7.57696 2.57286 7.32701 2.60868C6.64641 2.70221 6.15605 3.05883 5.98173 3.58699C5.82729 4.05626 5.95306 4.56451 6.30968 4.91278C7.12163 5.70642 8.19229 5.94681 8.75746 6.02004C9.0926 6.06304 9.32902 6.36951 9.28603 6.70422C9.24619 7.01271 8.98271 7.23758 8.68022 7.23758Z"
        fill="white"
      />
      <path
        d="M15.647 18.6213H4.35294C3.66915 18.6213 3.11353 18.0055 3.11353 17.2489V9.74951H16.8856V17.2489C16.8856 18.0055 16.33 18.6213 15.647 18.6213ZM4.33624 10.9722V17.2489C4.33624 17.3484 4.37923 17.4001 4.38956 17.4073L15.6446 17.3986C15.6223 17.397 15.6629 17.3456 15.6629 17.2489L15.647 10.9722H4.33624Z"
        fill="white"
      />
      <path
        d="M16.3713 10.9058H3.62853C2.31508 10.9058 1.24683 9.83756 1.24683 8.52413V8.39637C1.24683 7.08292 2.3151 6.01465 3.62853 6.01465H16.3714C17.6848 6.01465 18.7531 7.08292 18.7531 8.39637V8.52413C18.7531 9.83756 17.6848 10.9058 16.3713 10.9058ZM3.62853 7.23734C2.98932 7.23734 2.46952 7.75715 2.46952 8.39635V8.52411C2.46952 9.16331 2.98932 9.68312 3.62853 9.68312H16.3714C17.0106 9.68312 17.5304 9.16331 17.5304 8.52411V8.39635C17.5304 7.75715 17.0106 7.23734 16.3714 7.23734H3.62853Z"
        fill="white"
      />
    </svg>
  );
};

export const RewardCheck = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.5L3.66667 6L9 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const UnLockExpiredIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22444 2.50711C4.64564 2.9426 2.09748 6.19683 2.53298 9.77563C2.96847 13.3544 6.2227 15.9026 9.8015 15.4671C10.231 15.4148 10.6215 15.7206 10.6737 16.1501C10.726 16.5795 10.4202 16.97 9.99075 17.0223C5.55304 17.5623 1.51779 14.4026 0.977779 9.96488C0.437767 5.52717 3.59748 1.49192 8.03519 0.951908C11.8043 0.493254 15.2813 2.70299 16.5756 6.09668C16.7298 6.50091 16.5271 6.95357 16.1229 7.10774C15.7186 7.26191 15.266 7.05921 15.1118 6.65499C14.0679 3.91799 11.2622 2.13745 8.22444 2.50711Z"
        fill="white"
      />
      <path
        d="M19.4574 13.1646C19.4574 15.4719 17.587 17.3424 15.2796 17.3424C12.9723 17.3424 11.1018 15.4719 11.1018 13.1646C11.1018 10.8573 12.9723 8.98682 15.2796 8.98682C17.587 8.98682 19.4574 10.8573 19.4574 13.1646Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6432 11.5488C17.9588 11.8447 17.9748 12.3404 17.6789 12.656L15.231 15.2671C15.0829 15.4251 14.876 15.5147 14.6595 15.5147C14.443 15.5147 14.2361 15.4251 14.088 15.2671L12.6193 13.7005C12.3234 13.3848 12.3394 12.8891 12.655 12.5932C12.9706 12.2973 13.4663 12.3133 13.7622 12.6289L14.6595 13.586L16.536 11.5845C16.8318 11.2689 17.3276 11.2529 17.6432 11.5488Z"
        fill="#0ABDA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.01313 4.02588C9.44576 4.02588 9.79647 4.37659 9.79647 4.80921V9.50923C9.79647 9.78071 9.6559 10.0328 9.42496 10.1756C9.19402 10.3183 8.90564 10.3313 8.66281 10.2099L5.52947 8.64319C5.14252 8.44972 4.98568 7.97919 5.17915 7.59224C5.37263 7.20529 5.84316 7.04844 6.23011 7.24192L8.2298 8.24176V4.80921C8.2298 4.37659 8.58051 4.02588 9.01313 4.02588Z"
        fill="white"
      />
    </svg>
  );
};

export const VETip = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1104_2248)">
        <path
          d="M0 7C0.00218939 5.14416 0.74039 3.36495 2.05267 2.05267C3.36495 0.74039 5.14416 0.00218939 7 0C8.85584 0.00218939 10.635 0.74039 11.9473 2.05267C13.2596 3.36495 13.9978 5.14416 14 7C13.998 8.8559 13.2598 10.6352 11.9475 11.9475C10.6352 13.2598 8.8559 13.998 7 14C5.14416 13.9978 3.36495 13.2596 2.05267 11.9473C0.74039 10.635 0.00218939 8.85584 0 7H0ZM1.27273 7C1.27458 8.5184 1.87858 9.97408 2.95225 11.0477C4.02592 12.1214 5.4816 12.7254 7 12.7273C8.5184 12.7254 9.97408 12.1214 11.0477 11.0477C12.1214 9.97408 12.7254 8.5184 12.7273 7C12.7253 5.48165 12.1212 4.02607 11.0476 2.95244C9.97393 1.8788 8.51835 1.27475 7 1.27273C5.48165 1.27475 4.02607 1.8788 2.95244 2.95244C1.8788 4.02607 1.27475 5.48165 1.27273 7ZM6.04545 10.1634C6.04545 9.9102 6.14602 9.66741 6.32503 9.4884C6.50405 9.30939 6.74684 9.20882 7 9.20882C7.25316 9.20882 7.49595 9.30939 7.67497 9.4884C7.85398 9.66741 7.95455 9.9102 7.95455 10.1634C7.95455 10.4165 7.85398 10.6593 7.67497 10.8383C7.49595 11.0173 7.25316 11.1179 7 11.1179C6.74695 11.1179 6.50425 11.0174 6.32526 10.8386C6.14627 10.6597 6.04562 10.4171 6.04545 10.164V10.1634ZM6.36364 7.95709V3.04373H7.63636V7.95709H6.36364Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1104_2248">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterIconVE = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.75"
        y1="1.25"
        x2="15.25"
        y2="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="3.03564"
        y1="5.82129"
        x2="12.9642"
        y2="5.82129"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="5.32129"
        y1="10.3926"
        x2="10.6784"
        y2="10.3926"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const VEARROW = (props: any) => {
  return (
    <svg
      {...props}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.592725 9.07808L8.95679 0.714013M3.9397 0.545655L9.07801 0.592795L9.12515 5.7311"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const YouVotedAngleMatrix = () => {
  return (
    <svg
      width="120"
      height="22"
      viewBox="0 0 120 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 22H97.2747C99.6365 22 101.878 20.9564 103.398 19.1488L119.5 -7.15256e-07H8C3.58172 -7.15256e-07 0 3.58172 0 8V22Z"
        fill="url(#paint0_linear_1190_5368)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1190_5368"
          x1="101"
          y1="11"
          x2="2.97057"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7F43FF" />
          <stop offset="1" stopColor="#00C6A2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const YouVotedAngle = () => {
  return (
    <div className="relative  flex items-center justify-center">
      <div className="absolute z-10 transform scale-x-125">
        <YouVotedAngleMatrix />
      </div>
      <span className="relative z-20 text-xs text-white">
        <FormattedMessage id="you_voted" defaultMessage={'You Voted'} />
      </span>
    </div>
  );
};

export const NoResultListFilterIcon = () => {
  return (
    <svg
      width="106"
      height="95"
      viewBox="0 0 106 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="56.5" cy="57.5" r="37.5" fill="#172027" />
      <g filter="url(#filter0_b_1484_1509)">
        <circle cx="31.5" cy="39.5" r="29.5" fill="#23313C" fillOpacity="0.7" />
        <circle cx="31.5" cy="39.5" r="26.5" stroke="#444D53" strokeWidth="6" />
      </g>
      <rect
        x="53.8618"
        y="53.5171"
        width="21.6208"
        height="7.00142"
        rx="3.50071"
        transform="rotate(40.6388 53.8618 53.5171)"
        fill="#58636A"
      />
      <path
        d="M61.8082 60.9739C63.2417 59.3036 65.7553 59.1054 67.4329 60.5302L87.9093 77.9214C87.9093 77.9214 86.9987 79.9989 83 84C79.0013 88.0011 78 88 78 88L58.3314 71.1768C56.6506 69.7391 56.4556 67.2102 57.8961 65.5319L61.8082 60.9739Z"
        fill="#444D53"
      />
      <path
        d="M98.0621 15.5345C98.3843 14.6639 99.6157 14.6639 99.9379 15.5345L100.731 17.6781C100.832 17.9518 101.048 18.1677 101.322 18.2689L103.465 19.0621C104.336 19.3843 104.336 20.6157 103.465 20.9379L101.322 21.7311C101.048 21.8323 100.832 22.0482 100.731 22.3219L99.9379 24.4655C99.6157 25.3361 98.3843 25.3361 98.0621 24.4655L97.2689 22.3219C97.1677 22.0482 96.9518 21.8323 96.6781 21.7311L94.5345 20.9379C93.6639 20.6157 93.6639 19.3843 94.5345 19.0621L96.6781 18.2689C96.9518 18.1677 97.1677 17.9518 97.2689 17.6781L98.0621 15.5345Z"
        fill="#58636A"
      />
      <path
        d="M6.06215 68.5345C6.38431 67.6639 7.61569 67.6639 7.93785 68.5345L8.73106 70.6781C8.83235 70.9518 9.04816 71.1677 9.32188 71.2689L11.4655 72.0621C12.3361 72.3843 12.3361 73.6157 11.4655 73.9379L9.32188 74.7311C9.04816 74.8323 8.83235 75.0482 8.73106 75.3219L7.93785 77.4655C7.61569 78.3361 6.38431 78.3361 6.06215 77.4655L5.26894 75.3219C5.16765 75.0482 4.95184 74.8323 4.67812 74.7311L2.5345 73.9379C1.66389 73.6157 1.66389 72.3843 2.53451 72.0621L4.67812 71.2689C4.95184 71.1677 5.16765 70.9518 5.26894 70.6781L6.06215 68.5345Z"
        fill="#444D53"
      />
      <path
        d="M60.0621 2.5345C60.3843 1.66389 61.6157 1.66389 61.9379 2.53451L62.7311 4.67812C62.8323 4.95184 63.0482 5.16765 63.3219 5.26894L65.4655 6.06215C66.3361 6.38431 66.3361 7.61569 65.4655 7.93785L63.3219 8.73106C63.0482 8.83235 62.8323 9.04816 62.7311 9.32188L61.9379 11.4655C61.6157 12.3361 60.3843 12.3361 60.0621 11.4655L59.2689 9.32188C59.1677 9.04816 58.9518 8.83235 58.6781 8.73106L56.5345 7.93785C55.6639 7.61569 55.6639 6.38431 56.5345 6.06215L58.6781 5.26894C58.9518 5.16765 59.1677 4.95184 59.2689 4.67812L60.0621 2.5345Z"
        fill="#58636A"
      />
      <defs>
        <filter
          id="filter0_b_1484_1509"
          x="-2"
          y="6"
          width="67"
          height="67"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1484_1509"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1484_1509"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const NoResultFilter = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div>
        <NoResultListFilterIcon />
      </div>
      <div className="text-lg text-primaryText xsm:text-base mt-6">
        <FormattedMessage
          id="no_result_fould"
          defaultMessage={'Sorry, no result found.'}
        />
      </div>
    </div>
  );
};

export const DownArrowVE = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11372e-08 7.38265C-3.27892e-05 7.54503 0.0723861 7.70172 0.203402 7.82274L3.40758 10.781C3.70106 11.052 4.20422 11.0746 4.53142 10.8315C4.55284 10.8156 4.57321 10.7987 4.59242 10.781L7.79658 7.82274C8.09007 7.55179 8.06274 7.13509 7.73556 6.89203C7.58966 6.7836 7.40038 6.7236 7.20415 6.72358L5.75927 6.72357C5.48313 6.72357 5.25927 6.49971 5.25927 6.22357V0.997837C5.25927 0.446742 4.71866 0 4.05175 0C3.38485 0 2.84423 0.446742 2.84423 0.997825V6.22356C2.84423 6.49971 2.62037 6.72356 2.34423 6.72356H0.795846C0.360713 6.72356 0.00711989 7.01278 0.000104992 7.37175L1.11372e-08 7.38265Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UpArrowVE = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="transform rotate-180"
    >
      <path
        d="M1.11372e-08 7.38265C-3.27892e-05 7.54503 0.0723861 7.70172 0.203402 7.82274L3.40758 10.781C3.70106 11.052 4.20422 11.0746 4.53142 10.8315C4.55284 10.8156 4.57321 10.7987 4.59242 10.781L7.79658 7.82274C8.09007 7.55179 8.06274 7.13509 7.73556 6.89203C7.58966 6.7836 7.40038 6.7236 7.20415 6.72358L5.75927 6.72357C5.48313 6.72357 5.25927 6.49971 5.25927 6.22357V0.997837C5.25927 0.446742 4.71866 0 4.05175 0C3.38485 0 2.84423 0.446742 2.84423 0.997825V6.22356C2.84423 6.49971 2.62037 6.72356 2.34423 6.72356H0.795846C0.360713 6.72356 0.00711989 7.01278 0.000104992 7.37175L1.11372e-08 7.38265Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightArrowUnlockingVE = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" stroke="#7E8A93" />
      <path
        d="M3.75696 7.69982H11.6427M9.35696 5.25537L11.757 7.69982L9.35696 10.1443"
        stroke="#7E8A93"
        strokeLinecap="round"
      />
    </svg>
  );
};
